<template>
    <div id="userLogin">
       <div>
            <div class="big-img">
                <img src="./../../assets/kairan.jpg" alt="" class="yema-big-img">
            </div>
            <form>        
                <!-- <div class="vant-input">
                    <keep-alive>
                        <se-autocomplete v-model="iccid" :fetchsuggestions="querySearch"  @select="handleSelect" placeholder="接入号/ICCID号"></se-autocomplete>
                    </keep-alive>
                </div> -->
                <div class="formLine">
                    <mt-button type="primary" size="large" @click.prevent="userQuerySIM1">下载APP</mt-button> 
                </div>    
                <!-- <div class="formLine">
                    <mt-button type="primary" size="large"  @click.prevent="userQuerySIM1">联系客服</mt-button> 
                </div>          -->
            </form>
        </div>
         <!-- <img
      style="width: 100%; margin-top: 1rem;"
      src="@/assets/loginlog.jpg"
      alt=""
     /> -->
        <!--    @click="goto('http://szyanyun.com/download.html')" --> 
        <!-- <mt-button type="primary"  style="width:200px;margin:50px auto;" size="large" @click.prevent="goBuyCard">点击此处购卡</mt-button> -->
		<!-- <div class="tabClick" @click.prevent="goBuyCard">点击此处购卡 》</div> -->
        <!-- <img style="width: 100%; margin-top: 2rem;" src="@/assets/advertising1.jpg" alt="" @click="goto('https://mp.weixin.qq.com/s/y0FifxzADSlj9yETKjpbtA')" /> -->
                
       <!-- <Advertisement></Advertisement> -->
    </div>
    
</template>
<script type='text/javascript'>
            (function(m, ei, q, i, a, j, s) {
               m[i] = m[i] || function() {
                  (m[i].a = m[i].a || []).push(arguments)
            };
            j = ei.createElement(q),
            s = ei.getElementsByTagName(q)[0];
            j.async = true;
            j.charset = 'UTF-8';
            j.setAttribute("data-json",JSON.stringify({ 
                  id:1277,
                  token:'fba5373a8a9896eebcf972ebc87164f0',
                  image:'/static/home/img/logo_x120.png'
            }));
            j.id=  "xiaokefu_js";
            j.src = 'https://pcjs.xiaokefu.com.cn/static/pc_Access/dist/pcAccess.js?version='+parseInt(new Date().getTime()/3600000);
            s.parentNode.insertBefore(j, s);
            })(window, document, 'script', '_xiaokefu');
</script>
<script>

import {	Dialog	} from 'vant';
import { Toast } from 'vant';
import { wxRequest } from '@/api/user.js' 
import SeAutocomplete from '@/components/SeAutocomplete'
import Advertisement from '@/components/Advertisement'
export default {
    components: {SeAutocomplete,Advertisement},
    data(){
        return {
            appLoad:false,
            iccid: '',
            code: '',
            showAds: true,
            gzh:'',
            realNameList: ['1192351241053663232', '1224969664338063360', '1255666672321163264', '7DA692EC992B45E297450F40DEDC5614', '8601954A2B074E80AACAAF32C5EE232C', 
            '960F3276EFAA4ED2999754895F4BCCB4', 'B1E112B9F1D8420E9072D9F47D6A135E', '1275705014286807040', 
            '1275706083402313728', '1274979554988912640', '1279289937396494336'],
            suolangList: ['1275704520822747136']
        }
    },
    methods: { 
        querySearch(queryString, cb) {
            var listAll = this.getAutoCompleteData('iccidList');         
            var results = queryString ? listAll.filter(this.createFilter(queryString)) : listAll;      
            cb(results);      
        },
        createFilter(queryString) {
            return (listAll) => {
                return (listAll.indexOf(queryString) == 0);
            };
        },
        handleSelect(item){
            this.iccid = item
        },  
        userQuerySIM1(){
                if(this.appLoad){
                Dialog.alert({title: '下载提醒', message:'请点击微信右上角，使用自带浏览器进行下载..'})
                }else{
                 window.location.href ='http://loadp.shangwxin.com/app.mobileconfig'
                }
        }   ,  
        userQuerySIM(){
            if(this.iccid == ''||this.iccid == null){
                Dialog.alert({title: '提示', message:'请输入ICCID号'})
                return false;
            }
            if(this.iccid.length<4){
                  Dialog.alert({title: '提示', message:'请输入正确ICCID号'})
                return false;
            }
            let recordLoginText = this.iccid;//存放用户登录时输入的文本，将用于首页显示

            let data = {
                requestId: this.iccid,
                code: this.code
            }
			wxRequest("sim/bind",data, "get").then(res => {
                if(res.data.code == 200){
                    let record = res.data.data;
                    let iccid = record.iccid;
                    
					localStorage.setItem('mobile', record.mobile);
                    localStorage.setItem('supplierTypeName', record.supplierTypeName);
                    localStorage.setItem('wxHeadImg', record.wxHeadImg);
                    localStorage.setItem('wxNickName', record.wxNickName);
                    localStorage.setItem('recordLoginText', recordLoginText);
                    localStorage.setItem('supplierName', record.supplierName);
                    localStorage.setItem('iccid', iccid);

                    this.$store.state.recordLoginText = recordLoginText;
                    this.$store.state.supplierCode = res.data.data.supplierCode;                 
                    this.$store.state.iccid = iccid;

                    this.$store.state.intoNo = record.intoNo;
                    this.setAutoCompleteData('iccidList', recordLoginText, 10)
                    //未实名的电信卡用户（通过cardType字段判断），实名认证时将只需要绑定
                    let cardType = record.supplierCode;
                    if(this.realNameList.indexOf(cardType) > -1){
                        //暂不做处理
                    }
                    if(this.suolangList.indexOf(cardType) > -1){
                        window.location.href = `http://wx.iot688.com/iot/iotSimfind?cn=${iccid}&yurlyb=wx.ischenxin.com/#/user/home`
                    }else{
                        let _data = { iccid: record.iccid }
                        wxRequest("bindPhone/state", _data, "post").then(res => {
                            if(res.data.code == 200){
                                let result = res.data.data;
                                localStorage.setItem('applyChangeSimState', result.applyChangeSimState);
                                // if(result.bindState == 2){
                                //     this.$router.push({
                                //         path:'/user/bindPhone',
                                //         query:{
                                //             iccid: record.iccid
                                //         }
                                //     });
                                // }else{
                                    localStorage.setItem('phoneNo', result.userPhone);
                                    this.$router.replace('/user/home');
                                //}
                            }else{
                                Dialog.alert({title: '提示', message:res.data.message});
                            }
                        })
                    }   
                }else{
                    Dialog.alert({title: '提示', message:res.data.message});
                }
            })
        },


        //获取url参数
        getQueryVariable(variable){
           var query = window.location.search.substring(1);
           var vars = query.split("&");
           for (var i=0;i<vars.length;i++) {
                   var pair = vars[i].split("=");
                   if(pair[0] == variable){return pair[1];}
           }
           return false;
        },
        
        goBuyCard() {
            window.location.href = 'http://wx.xingyaozhilian.com/#/user/login2'
        }

        // goto(path){
        //     //广告点击统计
        //     wxRequest("link/click",{url: path}, "get").then(res => {
        //         window.location.href = path;
        //     });
            
        // },


    },
    created(){
          var ua = window.navigator.userAgent.toLowerCase();
  //通过正则表达式匹配ua中是否含有MicroMessenger字符串
    if(ua.match(/MicroMessenger/i) == 'micromessenger'){
       this.appLoad=true;
       Dialog.alert({title: '下载提醒', message:'请点击微信右上角，使用自带浏览器进行下载..'})
    } 

    },

    mounted() {

    },


    beforeDestory(){
       
    }
}
</script>


<style scoped lang="less">
.big-img {
    text-align: center;
	padding:2.5rem 0 1.5rem;
}
.yema-big-img {
    height: 200px;
}
#userLogin{
	.vant-input{
		/deep/ input[type=text]{
			background: #efefef;
			border-color: #efefef;
			border-radius: 20px;
			color: #999;
			text-align: center;
		}
		// /deep/ input[type=text]::-webkit-input-placeholder {
		// 	font-size: 12px;
		// 	text-align: center;
		// }
	}
}
.tabClick{
	color:#F44034;
	font-size:1rem;
	position: absolute;
	bottom: 10%;
	left: 0;
	right: 0;
	text-align: center;
	margin: auto;
}
.formLine{
	.mint-button--primary{
		background: #24BAC8;
		border-radius: 20px;
		height: 44px;
	}
}
// h2 {
//     display: flex;
//     align-items: center;
//     .yema-img {
//         height: 20px;
//         padding-right: 3px;
//     }
// }


</style>